import { render, staticRenderFns } from "./CardDashboard.vue?vue&type=template&id=b7962286&lang=pug&"
import script from "./CardDashboard.vue?vue&type=script&lang=js&"
export * from "./CardDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CardDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports